<template>
  <div class="ai-input-bar">
    <q-form
      class="ai-input-bar__form"
      @submit="
        () => {
          $emit('submitted', { input: userInput });
          userInput = '';
        }
      "
    >
      <q-input
        ref="ChatBotInput"
        v-model="userInput"
        standout
        rounded
        placeholder="Ask a question..."
        class="full-width "
        :class="{ '--shadow__bottom --bordered': addShadows }"
        style="border-radius: 28px"
        :disable="disable"
        debounce="300"
        @keydown="
          e => {
            if (e.keyCode == '38' || e.keyCode == '40') e.preventDefault();
          }
        "
        autofocus
        maxlength="500"
        hide-bottom-space
      >
        <!--<template v-slot:prepend>
          <q-icon
              name="sym_r_action_key"
              size="26px"
              style="margin-bottom: -4px"
          />
        </template>-->
        <template v-slot:append>
          <q-btn
            round
            dense
            :flat="!voiceRecognitionListening"
            :color="voiceRecognitionListening ? 'secondary' : 'text-text-light'"
            icon="sym_r_mic"
            class="q-mr-sm"
            :class="{ '--pulse': voiceRecognitionListening }"
            @click="
              () => {
                if (voiceRecognitionListening) {
                  voiceRecognition.stop();
                  voiceRecognitionListening = false;
                } else {
                  voiceRecognition.start();
                  voiceRecognitionListening = true;
                }
              }
            "
          >
            <q-tooltip
              anchor="center left"
              self="center right"
              :offset="[6, 6]"
            >
              {{
                voiceRecognitionListening ? "Listening..." : "Search By Voice"
              }}
            </q-tooltip>
          </q-btn>
          <q-btn
            round
            dense
            push
            color="secondary"
            icon="sym_r_send"
            @click="
              () => {
                $emit('submitted', { input: userInput });
                userInput = '';
              }
            "
            :disable="disable"
          />
        </template>
      </q-input>
    </q-form>
  </div>
</template>

<script>
import voiceRecognition from "@/mixins/voiceRecognition";

export default {
  name: "AiInputBar",
  mixins: [voiceRecognition],
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    addShadows: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      userInput: ""
    };
  },
  watch: {
    $route() {
      this.userInput = "";
    }
  },
  mounted() {
    this.initVoiceRecognition(this.handleVoiceRecognitionInput);
  },
  methods: {
    handleVoiceRecognitionInput(input) {
      this.userInput = input;
      this.$emit("submitted", { input: this.userInput });
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-input-bar {
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
}

.ai-input-bar__suggestions-container {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
